module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-LIGA-ANAK-PINTAR-2.b44341c0.png";